/// <reference path="Constants.js"/>
/// <reference path="Helpers.js"/>
/// <reference path="GeneralSettings.js" />

(function (sb) {
    sb.DynamicDates = (sb.DynamicDates || {});

    var DaysInMonth = sb.Constants.DaysInMonth;
    var _projectDatesWithData = null;
    var _datesWithData = null; 

    function getDatesWithData() {
        return Helpers.perfJSonCall({
            method: "GetDatesWithData",
            message: locale.get("Loading dates..."),
            fixCasing: true
        });
    }

    function setDatesWithData(dates){
		_datesWithData = dates;
    }

    function resetDatesWithData(){
        _datesWithData = _projectDatesWithData;
    }

    function fetchDates() {
		if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
			Storyboard.Dependency.start(['CROSSTABLEREPORT'], 'GetDatesWithData');
		}
        return getDatesWithData().done(function (data) {
            _projectDatesWithData = data.d;
			_datesWithData = data.d;
			if (window.ContentType === Storyboard.Constants.itemTypes.CROSSTABLE) {
				Storyboard.Dependency.complete(['CROSSTABLEREPORT'], 'GetDatesWithData');
			}
        });
    }

    function hasDataConnected(dateVariableId, dateOptions) {
        var { year, quarter, month, week, day } = dateOptions;

        if (!_datesWithData)
            return false;

        dateVariableId = dateVariableId || 1;

        var datesForDateVariableId = _datesWithData[dateVariableId];
        if (!datesForDateVariableId)
            return false;

        // Year
        var datesForYear = datesForDateVariableId[year];
        if (!datesForYear)
            return false;

        if (!quarter && !month && !week)
            return true;

        // Quarter
        if (quarter)
            return hasDatesForQuarter(datesForYear, year, quarter);

        // Week
        if (week)
            return hasDatesForWeek(datesForYear, year, week);

        // Month
        var datesForMonth = datesForYear[month];
        if (!datesForMonth)
            return false;

        if (!day)
            return true;

        // Day
        return hasDatesForDay(datesForMonth, day);
    }

    function hasDatesForQuarter(datesForYear, _year, quarter) {
        var quarters = {1: [1, 2, 3], 2: [4, 5, 6], 3: [7, 8, 9], 4: [10, 11, 12]};

        for (let month of quarters[quarter]) {
            if (month in datesForYear)
                return true;
        }

        return false;
    }

    function hasDatesForWeek(datesForYear, year, week) {
        var date = moment().year(year).week(week);

        var month = date.month() + 1;
        var startDay = date.startOf('week').format('D');
        var endDay = date.endOf('week').format('D');

        var datesForMonth = datesForYear[month];
        if (!datesForMonth)
            return false;

        for (let day = startDay; day <= endDay; day++) {
            if (hasDatesForDay(datesForMonth, day))
                return true;
        }

        return false;
    }

    function hasDatesForDay(datesForMonth, day) {
        return ((datesForMonth & DaysInMonth[day]) === DaysInMonth[day]);
    }

    function applyDayStyle(date, $dateVariableId) {
        var momentDate = moment(date);
        var year = momentDate.year();
        var month = momentDate.month() + 1;
        var day = momentDate.date();

        var dateVariableId = parseInt($dateVariableId.val() || 1, 10);

        if (sb.DynamicDates.hasDataConnected(dateVariableId, { year, month, day })) {
            return [true, "", ""];
        }

        return [true, "ui-state-disabled", "No data available for this day"];
    }

    function applyYearMonthStyle($dateVariableId){
        var dateVariableId = parseInt($dateVariableId.val() || 1, 10);
        
		//
		// Hack: had to use timeout to force FF correctly disable years - Chrome/Edge were working OK...
		//
		window.setTimeout(function () {
			var hideOptionsWithNoData =
				$("#lbSetting_3").closest(".dynamicFiltering").data("dynamicFiltering") === sb.Constants.DynamicFilteringStatus.OnHideOptionsWithNoData;

			if(hideOptionsWithNoData)
				applyHiddenStyles(dateVariableId);
			else
				applyDisabledStyles(dateVariableId);

		}, 0);
		
	}
	
	function backupRestoreDropdown(hiddenDropdownId, originalDropdownCssClass){
		//
		// Save inital content of dropdown in hidden select box
		// and use it to show/hide options in orignal years dropdown
		// 
		var $hiddenYearSelect = $("#" + hiddenDropdownId);
		if (!$hiddenYearSelect.length) {
			$('body').append('<select style="display:none" id="' + hiddenDropdownId + '"></select>');
			$hiddenYearSelect = $("#" + hiddenDropdownId);
			$(originalDropdownCssClass + " option").each(function (idx, elem) {
				$hiddenYearSelect.append($(elem).clone());
			});
		}
		else {
			$(originalDropdownCssClass).empty();
			$hiddenYearSelect.find('option').each(function (idx, elem) {
				$(originalDropdownCssClass).append($(elem).clone());
			});
		}
	}


	function hideYearsWithoutData(dateVariableId){
		var selectedYear = +($('select.ui-datepicker-year').val());

		backupRestoreDropdown("hiddenYearSelect", "select.ui-datepicker-year");

		$("select.ui-datepicker-year option").each(function (idx, elem) {
			var year = +($(elem).val());
			if (!Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year })) {
				$(elem).remove();
			}
		});

		$("select.ui-datepicker-year").val($('select.ui-datepicker-year option[value="' + selectedYear + '"]').length ? selectedYear : []);
	}


	function hideMonthsWithoutData(dateVariableId){
		var selectedYear = +($('select.ui-datepicker-year').val());
		var selectedMonth = +($('select.ui-datepicker-month').val());

		backupRestoreDropdown("hiddenMonthSelect", "select.ui-datepicker-month");

		if ($("select.ui-datepicker-year option").length) {
			$("select.ui-datepicker-month option").each(function (idx, elem) {
				var month = +($(elem).val()) + 1;
				if (!Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year: selectedYear, month })) {
					$(elem).remove();
				}
			});
		}
		else {
			$("select.ui-datepicker-month").empty();
		}

		$("select.ui-datepicker-month").val($('select.ui-datepicker-month option[value="' + selectedMonth + '"]').length ? selectedMonth : []);

	}

	function applyHiddenStyles(dateVariableId) {
		hideYearsWithoutData(dateVariableId);
		hideMonthsWithoutData(dateVariableId);
	}

	function applyDisabledStyles(dateVariableId) {
		var selectedYear = +($('select.ui-datepicker-year').val());
		
			$("select.ui-datepicker-year option").each(function (idx, elem) {
				var year = +($(elem).val());
				if (!Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year })) {
					$(elem)
						.css('color', 'rgba(18, 24, 33, 0.38)')
						.attr({"disabled": true, "title": "No data available for this year"});
				}
			});
		

		$("select.ui-datepicker-month option").each(function (idx, elem) {
			var month = +($(elem).val()) + 1;
			if (!Storyboard.DynamicDates.hasDataConnected(dateVariableId, { year: selectedYear, month} )) {
				$(elem)
					.css('color', 'rgba(18, 24, 33, 0.38)')
					.attr({"disabled": true, "title": "No data available for this month"});
			}
		}); 
	}

    function init() {
        fetchDates();
    }

    $(init);

    sb.DynamicDates.fetchDates = fetchDates;
    sb.DynamicDates.setDatesWithData = setDatesWithData;
    sb.DynamicDates.hasDataConnected = hasDataConnected;
    sb.DynamicDates.applyDayStyle = applyDayStyle;
    sb.DynamicDates.applyYearMonthStyle = applyYearMonthStyle;
    sb.DynamicDates.resetDatesWithData = resetDatesWithData;

}(window.Storyboard = (window.Storyboard || {})));
